import { useEffect, useState } from 'react';
import { Box, Grid, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useGlobal } from '../../hooks/useGlobal';

import api from '../../services/api';
import { FormBotaoRosa } from '../../components/FormBotaoRosa';
import { InputFormBase } from '../../components/InputFormBase';
import { schemaLogin } from '../../validations/schemasLogin';
import { errorMessage } from '../../util/toast';

// @ts-ignore
import imageLogin from '../../assets/login.svg'

export function SignIn() {
  const [form, setForm] = useState({
    email: '',
    senha: '',
  });
  const [erroInput, setErroInput] = useState(false);
  const [errosForm, setErrosForm] = useState({});
  const navigate = useNavigate();
  // @ts-ignore
  const { token, setToken, setUsuario } = useGlobal();

  useEffect(() => {
    if (token) {
      navigate('/home');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function capturarValorInput(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  function limparForm() {
    setForm({
      email: '',
      senha: ''
    });
    setErroInput(false);
  };

  function pegarInputOnBlur(e) {
    const valorDoInput = e.target.value.trim();
    const nomeDoInput = e.target.name;

    if (!valorDoInput) {
      setErrosForm({
        ...errosForm,
        [e.target.name]: `O campo ${e.target.name} é obrigatório.`
      })
      setErroInput(true);
    } else if (valorDoInput.length < 6 && nomeDoInput === 'senha') {
      setErrosForm({
        ...errosForm,
        [e.target.name]: `O campo ${e.target.name} deve ter pelo menos 6 caracteres.`
      });
      setErroInput(true);
    } else {
      setErrosForm({
        ...errosForm,
        [e.target.name]: ''
      });
      setErroInput(false);
    }
  }

  async function enviarFormulario(e) {
    e.preventDefault();

    try {
      await schemaLogin.validate(form, { abortEarly: false });

      const { data } = await api.post('/login', {
        email: form.email,
        senha: form.senha,
      });

      const { token: tokenCreate, usuario } = data;

      setToken(tokenCreate);
      setUsuario(usuario);

      limparForm();
      navigate('/home');
    } catch (erros) {
      if (erros.inner) {
        erros.inner.forEach(erro => {
          if (!erro.path) {
            return;
          }
          const menssagemErro = `${erro.message.charAt(0).toUpperCase()}${erro.message.slice(1)}.`;

          setErrosForm({
            ...errosForm,
            ...{ [erro.path]: menssagemErro }
          });
        });
      } else {
        errorMessage(erros.response.data.replace('mensagem: ', ''));
      }
      setErroInput(true);
    }
  };

  return (
    <>
      <Grid container component='main' sx={{ height: '100vh', backgroundColor: '#F8F8F9' }}>
        <Grid
          item
          xs={false}
          sm={5}
          md={4}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundImage: `url(${imageLogin})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <Typography
            component='h1'
            variant='h5'
            sx={{
              mt: '163px',
              width: '388px',
              fontFamily: 'Montserrat',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '31px',
              textAlign: 'center',
              color: '#034A2A',
            }}
          >
            Gerencie todos os pagamentos da sua empresa em um só lugar.
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={7}
          md={8}
          component={Paper}
          elevation={0}
          square
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: '#F8F8F9'
          }}
        >
          <Box
            sx={{
              mt: '235px',
              mx: 4,
              width: '355px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography
              component='h1'
              variant='h5'
              sx={{
                mb: '32px',
                fontFamily: 'Montserrat',
                fontWeight: 700
              }}
            >
              Faça seu login!
            </Typography>

            <Box
              component='form'
              noValidate
              onSubmit={enviarFormulario}
              sx={{
                width: '100%',
              }}
            >
              <InputFormBase
                erroInput={erroInput && errosForm.hasOwnProperty('email') && errosForm['email']}
                login={true}
                etiqueta={'E-mail'}
                tipoInput={'email'}
                value={form.email}
                onChange={(e) => capturarValorInput(e)}
                onBlur={(e) => pegarInputOnBlur(e)}
                // @ts-ignore
                erroMensagem={errosForm?.email}
              />

              <Box sx={{ display: 'flex', position: 'relative', }}>
                <Link
                  href='#'
                  variant='body2'
                  color='#DA0175'
                  underline='always'
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: 1,
                    fontFamily: 'Nunito',
                    fontStyle: 'normal',
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '18px',
                  }}
                >
                  Esqueceu a senha?
                </Link>

                <InputFormBase
                  erroInput={erroInput && errosForm.hasOwnProperty('senha') && errosForm['senha']}
                  login={true}
                  etiqueta={'Senha'}
                  tipoInput={'password'}
                  value={form.senha}
                  onChange={(e) => capturarValorInput(e)}
                  onBlur={(e) => pegarInputOnBlur(e)}
                  // @ts-ignore
                  erroMensagem={errosForm?.senha}
                />
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FormBotaoRosa
                  type='submit'
                  variant='contained'
                >
                  Entrar
                </FormBotaoRosa>

                <Box>
                  <Typography
                    component='span'
                    variant='body2'
                    sx={{
                      mr: '4px',
                      fontFamily: 'Nunito',
                      fontWeight: 400
                    }}
                  >
                    Ainda não possui uma conta?
                  </Typography>

                  <Link
                    component={RouterLink}
                    to={'/cadastro'}
                    color='#DA0175'
                    sx={{
                      fontFamily: 'Nunito',
                      fontStyle: 'normal',
                      fontWeight: 600,
                      fontSize: '0.875rem',
                      lineHeight: '1.25rem',
                      textDecorationLine: 'underline',
                    }}
                  >
                    Cadastre-se
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
